
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"currency"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storeConfig"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extra_days_artwork"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"extra_days_new_artwork"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"extra_days_print_artwork"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"extra_days_new_print_artwork"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"highest_setup_charge"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"excl_tax"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"incl_tax"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"cutoff_time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"superfast_cutoff_time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"blackout_days"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"base_currency_code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"base_currency_symbol"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"default_display_currency_code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"default_display_currency_symbol"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"available_currency_codes"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"currencySymbols"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"symbol"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":700}};
    doc.loc.source = {"body":"# Slim storeConfig for shell first paint (currency/VAT/cutoff). Blog + livechat\n# live in clientStoreConfig.graphql (ssr: false).\nquery currency {\n    storeConfig {\n        extra_days_artwork\n        extra_days_new_artwork\n        extra_days_print_artwork\n        extra_days_new_print_artwork\n        highest_setup_charge {\n            excl_tax\n            incl_tax\n        }\n        cutoff_time\n        superfast_cutoff_time\n        blackout_days\n    }\n    currency {\n        base_currency_code\n        base_currency_symbol\n        default_display_currency_code\n        default_display_currency_symbol\n        available_currency_codes\n    }\n    currencySymbols {\n        code\n        symbol\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["currency"] = oneQuery(doc, "currency");
        
